import { TStrictObject } from '@interfaces/common';

export function isEmptyObjectRecursive<T>(obj: TStrictObject<T> | null): boolean {
	if (obj === null) {
		return true;
	}

	if (Object.keys(obj).length === 0) {
		return true;
	}

	return Object.values(obj).every((value) => {
		if (value === null || value === undefined || value === '') {
			return true;
		}

		if (typeof value === 'object') {
			return isEmptyObjectRecursive(value as TStrictObject<typeof value>);
		}

		return false;
	});
}
